import React from 'react';
import { useGenGridCol } from '../../../../../utils/ComponentHelper';
import { displayAmountCurrying } from '../../../../../utils';
import { useTranslation } from '../../../../../hooks';
import { ExecutionType, Operation } from '../types/OperationDetailsRequestBody';
import { getSwapPathDisplay } from '../utils/getSwapPathDisplay';

interface IProps {
  operationDetails: Operation[];
}

const useSwapDetailsExactPayTable = ({ operationDetails }: IProps) => {
  const { translate } = useTranslation();

  // Exact Pay
  const exactPayColumns = [
    // useGenGridCol('operationSequence', {
    //   minWidth: 140,
    // }),
    // useGenGridCol('batchId', {
    //   minWidth: 140,
    // }),
    // useGenGridCol('toAddress', {
    //   minWidth: 350,
    // }),
    useGenGridCol('executionType', {
      minWidth: 250,
    }),
    useGenGridCol('exactPayAmount', {
      minWidth: 140,
    }),
    useGenGridCol('minGetAmount', {
      minWidth: 140,
    }),

    useGenGridCol('swapPath', {
      minWidth: 250,
    }),
  ];

  const exactPayRows = operationDetails.map((operation: any, index: number) => {
    const toMinGetDisplayAmount = displayAmountCurrying(
      operation.execution_detail?.decimals_get || ''
    );
    const toExactPayDisplayAmount = displayAmountCurrying(
      operation.execution_detail?.decimals || ''
    );

    const swapPathDisplay = getSwapPathDisplay(operation.execution_detail?.swap_path || []);

    return {
      id: index,
      operationSequence: operation.operation_seq || '',
      batchId: operation.batch_id || '',
      toAddress: operation.execution_detail?.to_address || '',
      executionType:
        translate(`enumConstants.${ExecutionType[operation.execution_detail?.execution_type]}`) ||
        '',
      exactPayAmount: `${toExactPayDisplayAmount(operation.execution_detail?.amount || '')} ${
        operation.execution_detail?.asset_name || ''
      }`,
      minGetAmount: `${toMinGetDisplayAmount(operation.execution_detail?.amount_get_min || '')} ${
        operation.execution_detail?.asset_name_get || ''
      }`,

      swapPath: swapPathDisplay,
    };
  });

  return { exactPayColumns, exactPayRows };
};

export default useSwapDetailsExactPayTable;
